import React, { useState, useEffect } from 'react';
import { Edit, SimpleForm, FileInput, ImageField, useUpdate, useNotify, useRedirect, Toolbar, SaveButton, required } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { uploadImage } from '../../../config/services/strapi/strapi';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';

function ProyectosEdit(props: any) {
  const [portadaChanged, setPortadaChanged] = useState(false);
  const [update] = useUpdate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'plg-proyectoss';

  useEffect(() => {
    document.title = 'Editar Proyecto';
  }, []);

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      const payload: Record<string, any> = { descripcion: data.descripcion };

      if (portadaChanged && data.portada?.rawFile) {
        const up = await uploadImage(data.portada.rawFile, token!);
        payload.portada = { id: up.id };
      }

      update(resourceName, { id: data.id, data: payload }, {
        onSuccess: () => {
          notify('Proyecto actualizado');
          redirect('list', resourceName);
        }
      });
    } catch (e) {
      notify('Error al actualizar', { type: 'error' });
    }
  };

  return (
    <Edit {...props}>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <RichTextInput 
          source="descripcion" 
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />
        <FileInput source="portada" label="Cambiar Portada" onChange={() => setPortadaChanged(true)}>
          {portadaChanged ? <ImageField source="src" /> : <ImageField source="url" />}
        </FileInput>
      </SimpleForm>
    </Edit>
  );
}

export default ProyectosEdit;